module.exports = __webpack_public_path__ + "media/icons/upload-route-complete-icon-4af59315.svg";